import React, { useEffect } from 'react';
import { acciones_uiimh } from '../../json/acciones_uiimh';
import './uiimh.css';
import './main.css';
import './graphic.css';

const Uiimh = () => {
  
   
   useEffect(() => {
     window.scrollTo(0, 0);
   }, []);

  

  return (
    <>
      
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Trabajo.svg")` }}>

            </div>
          </div>
          <div className='secretaria_name'>
            <h1>Unidad Institucional para la Igualdad Entre Mujeres y Hombres</h1>
          </div>
          <div className='secretaria_funciones'>
            
            <hr className='hr-gob'/>
             
            
            <div className='row'>
              {
                acciones_uiimh.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_acciones'>
                            <div className='card_cero'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">Ver</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }

              </div>
              
          </div>
        </div>

        <div className='secretaria_funciones'>
            
            <hr className='hr-gob'/>
            
              <img  className="imagen-mision" src={"../uiihm/uiihm.jpg"}/>
            
            
            
          
          
      </div>
    


        <div className='secretaria_funciones'>
            <h3 className='title'>Directorio</h3>
            <hr className='hr-gob'/>
            
              <img  className="imagen-mision" src={"../uiihm/directorio.jpg"}/>
            
            
            
          
          
      </div>
      
      <div className='secretaria-redes'>
                <a href='https://www.facebook.com/Strabajohgo' target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
                <a href='https://www.instagram.com/strabajohgo/' target="_blank"><i class="fa-brands fa-instagram"></i></a>
                <a href='https://twitter.com/strabajohgo' target="_blank"><i class="fa-brands fa-twitter"></i></a>
              </div>

      </div>
    </>
  )
}

export default Uiimh